import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year6/Spring/Decimals/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Decimals',
  field: 'Number',
  weeks: [5, 6],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Decimals/1PlaceValueWithin1" */ './1PlaceValueWithin1'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Decimals/2PlaceValueIntegersAndDecimals" */ './2PlaceValueIntegersAndDecimals'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(/* webpackChunkName: "Year6/Spring/Decimals/3RoundDecimals" */ './3RoundDecimals')
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Decimals/4AddAndSubtractDecimals" */ './4AddAndSubtractDecimals'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Decimals/5MultiplyBy10100And1000" */ './5MultiplyBy10100And1000'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Decimals/6DivideBy10100And1000" */ './6DivideBy10100And1000'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Decimals/7MultiplyDecimalsByIntegers" */ './7MultiplyDecimalsByIntegers'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Decimals/8DivideDecimalsByIntegers" */ './8DivideDecimalsByIntegers'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Decimals/9MultiplyAndDivideDecimalsInContext" */ './9MultiplyAndDivideDecimalsInContext'
        )
    })
  ]
});
export default Block;
